export const bitcoinImg = "https://openbook.0.srcpad.pro/static/assets/bitcoin.png";
export const counterpartyImg = "https://openbook.0.srcpad.pro/static/assets/counterparty.png";
export const leatherImg = "https://openbook.0.srcpad.pro/static/assets/leather.png";
export const okxImg = "https://openbook.0.srcpad.pro/static/assets/okx.png";
export const tapWalletImg = "https://openbook.0.srcpad.pro/static/assets/tapwallet.png";
export const unisatImg = "https://openbook.0.srcpad.pro/static/assets/unisat.png";
export const phantomImg = "https://openbook.0.srcpad.pro/static/assets/phantom.svg";
export const walletImg = "https://openbook.0.srcpad.pro/static/assets/wallet.svg";
export const logoutImg = "https://openbook.0.srcpad.pro/static/assets/logout.svg";
